import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { Box, Autocomplete, Divider, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Header from "../../../Layout/Header";

import CallAlertBar from "../../../Layout/Alertbar";
import { Today } from "@mui/icons-material";
import { AppBar, Toolbar, } from '@mui/material';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
const AddOvertime = ({ handleBackWinderMachineEntry }) => {
    const [employeeId, setEmployeeId] = useState('');
    const [overtimeDate, setOvertimeDate] = useState(dayjs());


    const [duration, setDuration] = useState('');
    const [shiftId, setShiftId] = useState('');
    const [employee, setEmployee] = useState('');
    const [employeelist, setEmployeelist] = useState([]);
    const [selectedShiftCode, setSelectedShiftCode] = useState(null);
    const [shiftCodes, setShiftCodes] = useState([]);
    const [reportShiftCode, setReportShiftCode] = useState('');
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const ViewHideMsg = (msg, securityvalue, open) => {
        setParentRollSeverityvalue(securityvalue);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(securityvalue);
        setParentRollMsgOpen(open);
    }

    const handleShiftChange = (event, value) => {


        if (value) {
            setSelectedShiftCode(value);
            setShiftId(value.shiftid);
            setReportShiftCode(value.shiftcode);
        }
        else {
            setSelectedShiftCode(null);
            setShiftId('');
            setReportShiftCode('');
        }
    }
    const [validationErrors, setValidationErrors] = useState({});
    // Validate input fields
    const validateInputs = () => {
        const errors = {};
        if (!employeeId) {
            ViewHideMsg("Employee is required.", 'warning', true);
            errors.employeeId = "Employee is required";

        }
        else if (!overtimeDate) {
            ViewHideMsg("Overtime Date is required.", 'warning', true);
            errors.overtimeDate = "Overtime Date is required";
        }
        else if (!duration || isNaN(duration)) {
            ViewHideMsg("Duration must be a valid number", 'warning', true);
            errors.duration = "Duration must be a valid number";
        }
        else if (duration < 0) {
            ViewHideMsg("Duration cannot be a negative number.", 'warning', true);
            errors.duration = "Duration cannot be a negative number.";
        }

        else if (!shiftId) {
            ViewHideMsg("Shift is required", 'warning', true);
            errors.shiftId = "Shift is required";
        }
        else {
            ViewHideMsg("", 'warning', false);
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = () => {
        // Submit logic for adding overtime
        // API call to add overtime to the database
        if (!validateInputs()) return;

        const params = {
            id_overtime: 0,
            id_employee: employeeId,
            id_shift: shiftId,
            overtime_date: dayjs(overtimeDate).format("YYYY-MMM-DD"),
            duration_mins: duration,
            id_approved_by: 0,
        };

        callApi(API_ENDPOINTS.EMPLOYEE_InsertEmployeeOverTimeDetails, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    if (data === 'Employee Over time added successfully!') {
                        ViewHideMsg(data, 'success', true);
                    }
                    else {
                        ViewHideMsg(data, 'warning', true);
                    }
                }
            })
            .catch(error => alert(error.message));
    };

    const handleEmployeeChange = (event, value) => {
        if (value) {
            setEmployee(value);
            setEmployeeId(value.id);
        }
        else {
            setEmployee('');
            setEmployeeId('');
        }
    }

    useEffect(() => {
        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLists, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setEmployeelist(data);
                }
            })
            .catch(error => alert(error.message));
    }, []);

    // Fetch shift codes function
    const fetchShiftCodes = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem('companyid') };

        try {
            const data = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para);

            if (data && data.length > 0) {
                setShiftCodes(data);
                const initialShift = data.find(shift => shift.shiftid === selectedID) || data[0];
                setSelectedShiftCode(initialShift);
                setShiftId(initialShift.shiftid);
                setReportShiftCode(initialShift.shiftcode);

            }
        } catch (error) {
            alert(error.message);
        }
    };

    // UseEffect to load shift codes on component mount
    useEffect(() => {
        fetchShiftCodes();
    }, []);


    const ClearAll = async () => {
        // Assuming you might have asynchronous operations in the future
        try {
            setEmployeeId('');
            setOvertimeDate(dayjs());
            setDuration('');
            setShiftId('');
            setEmployee('');
            setSelectedShiftCode(null);
            setReportShiftCode('');
            setValidationErrors({});

            setParentRollMsgOpen(false);
        } catch (error) {
            console.error('Error during ClearAll:', error);

        }
    };

    return (
        <Box padding={0}>
            <Header title={'Add Employee Overtime'} subtitle='' callback={handleBackWinderMachineEntry} />
            <Divider />
            {/* Message box detail */}
            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


            <Grid container spacing={2} padding={3}>
                <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Employee Name</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4.1} lg={4.1} xl={4.1}>
                        <Autocomplete
                            fullWidth
                            value={employee}
                            onChange={handleEmployeeChange}
                            size="small"
                            style={{ fontSize: '12px' }}
                            options={employeelist}
                            getOptionLabel={(option) => option?.name || ''}

                            renderInput={(params) =>
                                <TextField required
                                    placeholder="Select Employee"
                                    // helperText={errorMessage}
                                    // error={errorMessage && errorMessage.length ? true : false}
                                    {...params} variant="outlined" />}
                        />
                    </Grid>
                </Grid>

                <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Overtime Date</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={2.1} lg={2.1} xl={2.1}>



                        <FormControl size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Overtime Date"
                                    value={overtimeDate}
                                    onChange={(newValue) => setOvertimeDate(newValue)}

                                    slotProps={{ textField: { size: 'small' } }}
                                    renderInput={(props) => <TextField {...props} />}
                                    format="DD-MMM-YYYY"
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                        <TextField
                            label="Duration (Minutes)"
                            type="number"
                            size='small'
                            fullWidth
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Shift</Typography>
                    </Grid>
                    <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                        <FormControl fullWidth size="small">
                            <Autocomplete
                                fullWidth
                                value={selectedShiftCode}
                                onChange={handleShiftChange}
                                size="small"
                                style={{ fontSize: '12px' }}
                                options={shiftCodes}

                                getOptionLabel={(option) => `${option.shiftcode}`}
                                renderInput={(params) =>
                                    <TextField required
                                        placeholder="Select Shift Code"
                                        {...params} variant="outlined" />}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                {/* <Grid container padding="5px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} >
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">

                    </Grid>
                    <Grid item xs={12} sm={12} md={4.1} lg={4.1} xl={4.1}>
                        <Button variant="contained" color="secondary" sx={{ textTransform: 'none' }} onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Grid>
                </Grid> */}

            </Grid>

            <Box justifyContent={'space-between'} sx={{
                position: 'fixed',
                bottom: 0,
                width: '100%'
            }}>
                <Divider style={{ backgroundColor: '' }} />
                <Toolbar >
                    <Button variant='contained' style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }} onClick={handleSubmit} type="Submit">
                        Save
                    </Button>

                    <Button
                        onClick={ClearAll}
                        variant='contained'
                        style={{ marginRight: '0px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                    >
                        Clear
                    </Button>
                </Toolbar>
            </Box>
        </Box>
    );
};

export default AddOvertime;
